import { gql } from "@apollo/client";


export const RENAME_CHAT = gql`
    mutation RenameChat($id: ID!, $name: String!) {
        renameChat(id: $id, name: $name) {
            id
            name
        }
    }
`;